<template>
  <div class="article-3">
    <div class="article__info">
      <h1 class="article__title">第三勢力票在哪裡？</h1>
      <h2 class="article__subtitle">民眾黨能複製時力成功模式？</h2>
      <div class="article__reporter">聯合報 記者：鄭媁、張文馨／報導</div>
    </div>

    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-3-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">
        <span>台灣民眾黨進攻國會，日前發起「全台大眾走」活動，民眾黨主席柯文哲（中）親自授旗。記者侯永全／攝影</span>
      </figcaption>
    </figure>

    <p class="article__paragraph">第三勢力競逐2020大選，打出超越藍綠的訴求，尤其以台北市長柯文哲為首的台灣民眾黨，能否一舉進攻國會，成為各界矚目焦點。根據近幾年的政黨票分析顯示，小黨必須推區域立委參選，或是有母雞帶頭，才能催化政黨票。</p>
    <p class="article__paragraph">民眾黨這次提名18位區域立委，從選戰布局來看，有15位是在六都參選，這可能是參考時代力量在2016年的選戰成績單，策略相當明顯。</p>
    <p class="article__paragraph">2016年，時代力量成為立法院最大的第三勢力，當時不少人認為，政治光譜偏深綠的時力，讓台灣團結聯盟泡沫化，並且取而代之進入立法院。仔細比較中選會的投票資料，將發現時力在2016年的得票熱區，多數不同於台聯在2012年的得票區，但確實有部分重疊。</p>

    <h3 class="article__paragraph-title">泛綠政黨票集中在都會區</h3>
    <p class="article__paragraph">以時代力量為例，政黨票較高區域集中在新竹縣市、台中市、台北市為主，台聯則是在高雄、台南較具實力。但這兩黨得票數排名前20的選區裡，有8個重疊，顯見票源有轉移現象。</p>

    <!-- chart-1 -->
    <div class="article__chart">
      <div class="article__chart-caption">台聯、時力的政黨票熱區</div>
      <div class="article__chart-figure article-3__chart-figure-1">
        <SvgSymbol use="#article-3-chart-1"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會</span><!--
      --><span>本文自行整理，政黨得票熱區是以政黨得票數來計算。</span>
      </div>
      <div class="article__chart-extended">
        <a class="article__chart-extended-link"
          :href="`${baseUrl}images/article-3-chart-1-table.png`"
          target="_blank"
          title="政黨票熱區清單"><!--
        --><SvgSymbol use="#link"/><!--
        --><span>政黨票熱區清單</span>
        </a>
      </div>
    </div>

    <p class="article__paragraph">更值得注意的是，時力帶給民眾黨的選戰啟示。時力在台中市提名洪慈庸，不僅開拓一席區域立委，台中市八個選區中，有五個選區開出超過7%的政黨票。</p>
    <p class="article__paragraph">不過，時力在台北市、新北市提名的林昶佐與黃國昌，區域立委雖然勝出，政黨票在這兩選區卻不如預期，甚至分居全市倒數第二、第三，但在雙北選區裡，各區支持度都接近時力的全國總得票率6.11%。</p>
    <p class="article__paragraph">時力在新竹市提名邱顯智不敵民進黨柯建銘，卻衝出時力政黨票的全國最高票，將近2萬票、得票率約9%；這些均顯示提名區域立委後，影響力會有向外擴散效果，進而拉高政黨票。</p>

    <h3 class="article__paragraph-title">泛藍政黨票非都會區為主</h3>
    <p class="article__paragraph">四年前，同樣打出「超越藍綠」牌的民國黨，喊出「20萬黨員、一人拉10票」訴求，黨主席徐欣瑩更擔任親民黨主席宋楚瑜的副手，角逐2016年正副總統，只是民國黨提名14位區域立委全軍覆沒，政黨票只拿下19萬7627票。</p>
    <p class="article__paragraph">民國黨的選民結構，明顯落在桃竹苗一帶，這與徐欣瑩從政背景有關，她父親曾任新竹縣新豐鄉鄉長，徐欣瑩從當地選議員開始，更曾在2012年拿下全國立委最高票，整個家族和派系的政治實力，以新竹縣和苗栗縣為主。</p>
    <p class="article__paragraph">巧合的是，對照親民黨2012年政黨得票排行，民國黨的政黨票排名前20熱區，有高達13個區域與2012年親民黨重疊，尤其是新竹縣、新竹市和苗栗縣。</p>

    <!-- chart-2 -->
    <div class="article__chart">
      <div class="article__chart-caption">民國黨、親民黨的政黨票熱區</div>
      <div class="article__chart-figure article-3__chart-figure-2">
        <SvgSymbol use="#article-3-chart-2"/>
      </div>
      <div class="article__chart-annotation"><!--
      --><span>資料來源：內政部、中選會</span><!--
      --><span>本文自行整理，政黨得票熱區是以政黨得票數來計算。</span>
      </div>
      <div class="article__chart-extended">
        <a class="article__chart-extended-link"
          :href="`${baseUrl}images/article-3-chart-2-table.png`"
          target="_blank"
          title="政黨票熱區清單"><!--
        --><SvgSymbol use="#link"/><!--
        --><span>政黨票熱區清單</span>
        </a>
      </div>
    </div>

    <p class="article__paragraph">民國黨雖提名區域立委，加上徐欣瑩和宋楚瑜扮演母雞，只是優勢選區過於集中，以及這些選區人口數偏少，導致無法衝過政黨門檻；相形之下，曾在全國經營多年，數度角逐中央層級選舉的親民黨，靠著全台累積得票數，仍保住國會命脈。</p>
    <p class="article__paragraph">這些第三勢力的政黨票，若再從政治光譜分類，可以明顯發現，立場偏綠的熱區，多數集中在都會區，至於原本色彩偏藍的政黨票，則是落在非直轄市居多。</p>
    <p class="article__paragraph">因此，民眾黨的大本營，由柯文哲從台北市出發，再挑選子弟兵投入六都的區域選舉，借鏡歷年政黨票的趨勢明顯；只是藍綠選票會不會成功轉移到民眾黨的政黨票，恐怕又是另一回事。</p>

  </div>
</template>

<script>
export default {
  name: 'Article3',
  inject: [ 'baseUrl' ]
}
</script>

<style lang="scss">
.article-3 {

  &__chart-figure {
    &-1 {
      @include use-fixed-ratio(821.51, 772.11);
    }

    &-2 {
      @include use-fixed-ratio(1026.79, 912.48);
    }

    &-3 {
      @include use-fixed-ratio(1158.94, 1216.03);
    }
  }
}
</style>
